export const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export const ONE_WEEK_MS = ONE_DAY_MS * 7;
export const THIRTY_DAYS_MS = ONE_DAY_MS * 30;

export const ROOT_KEY = 'timeline_functional';

export const DEFAULT_CONFIG = {
  version: 0,
  expirationMillis: ONE_DAY_MS,
};
